export const stepConfig = [
  {target: '.createCourseButton', key: 'createCourseButton'},
  {target: '.CourseCardContainer', key: 'courseCardContainer'},
  {target: '.courseCardInfo', key: 'courseCardInfoRightBox'},
  {target: '.courseCardActions', key: 'courseKebab'},
];
